import React from 'react';
import './PreflopStats.css';
import { useSelector } from 'react-redux';
import { selectGeneralStats } from '../../selectors';
import Card from '../../../../components/Card/Card';
import Flex from '../../../../components/Flex/Flex';
import Text from '../../../../components/Text/Text';

export const PreflopStatsList = React.memo(
  ({
    names,
    values,
    compact,
    overview,
  }: {
    names: Array<string>;
    values: Array<number | null>;
    compact?: boolean;
    overview?: boolean;
  }) => {
    const gap = overview ? 4 : compact ? 2 : 8;
    const columnGap = overview ? 3 : compact ? 4 : 8;

    const textSize = overview || compact ? 2 : undefined;

    return (
      <Flex
        gap={columnGap}
        className={
          overview
            ? 'PreflopStatsList--overview'
            : compact
              ? 'PreflopStatsList--compact'
              : undefined
        }
      >
        <Flex vertical gap={gap}>
          {names.map((x, index) => (
            <Text key={index} type="primary" bold size={textSize}>
              {x}
            </Text>
          ))}
        </Flex>
        <Flex vertical gap={gap} align="center">
          {values.map((x, index) => (
            <Text key={index} bold size={textSize}>
              {x === null ? '-' : x}
            </Text>
          ))}
        </Flex>
      </Flex>
    );
  },
);

const PreflopStats = React.memo(() => {
  const generalStats = useSelector(selectGeneralStats);
  return (
    <Card title="Preflop">
      <Flex className="PreflopStats__content" gap={16} showDivider justify="space-around">
        <Flex gap={8} className="PreflopStats__content-group">
          <Flex vertical align="flex-end">
            <Flex flex align="center">
              <Text size={3} bold type="primary">
                VPIP
              </Text>
            </Flex>
            <Flex flex align="center">
              <Text size={3} bold type="primary">
                PFR
              </Text>
            </Flex>
          </Flex>
          <Flex vertical align="center">
            <Text size={6} bold>
              {generalStats.vpip ?? '-'}
            </Text>
            <Text size={6} bold>
              {generalStats.pfr ?? '-'}
            </Text>
          </Flex>
        </Flex>

        <PreflopStatsList
          names={['3bet', 'F3bet', 'SQZ', 'CC']}
          values={[
            generalStats.threebet ?? null,
            generalStats.foldedtothreebetpreflop ?? null,
            generalStats.squeeze ?? null,
            generalStats.coldcall ?? null,
          ]}
        />

        <PreflopStatsList
          names={['WTSD', 'WWSF', 'W$SD']}
          values={[
            generalStats.sawshowdown ?? null,
            generalStats.wonwhensawflop ?? null,
            generalStats.wonshowdown ?? null,
          ]}
        />

        <PreflopStatsList
          names={['Call3bet', '4bet', 'F4bet', '5bet']}
          values={[
            generalStats.calledthreebetpreflop ?? null,
            generalStats.raisedthreebetpreflop ?? null,
            generalStats.foldedtofourbetpreflop ?? null,
            generalStats.raisedfourbetpreflop ?? null,
          ]}
        />

        <PreflopStatsList
          names={['SB resteal', 'BB resteal']}
          values={[generalStats.smallblindresteal ?? null, generalStats.bigblindresteal ?? null]}
        />
      </Flex>
    </Card>
  );
});

export default PreflopStats;
